import { required, maxLength, email } from 'vuelidate/lib/validators'

const personalData = {
  gender: { required }
}

const personalContact = {
  cellularPhone: { required },
  email: { required, email },
  homePhone: { },
}

const personalName = {
  lastName: {required},
  lastNameGenitive: {required},
  firstName: {required},
  firstNameGenitive: {required},
  middleName: {},
  middleNameGenitive: {},
}

const addressGar = {
  country: { required },
  postalCode: { required },
  flat: { required },
  fullAddress: { required }
}

export {
  personalContact,
  personalData,
  personalName,
  addressGar
}
